import React from "react"

import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Grow from "@material-ui/core/Grow"
import Popper from "@material-ui/core/Popper"
import MenuList from "@material-ui/core/MenuList"

import Card from "../atoms/Card"
import Box from "../atoms/Box"

// This wrapper is used for live editing (always open)
export const AlwaysOpenMegaMenu = ({ card, children, ...props }) => {
  return (
    <Box width="100%" position="relative">
      <Card
        useCard
        borderRadius="none"
        {...card}
        boxShadow={card?.boxShadow || "md"}
        theme={card?.theme || "default"}
      >
        {children}
      </Card>
    </Box>
  )
}

export const PopperMegaMenu = ({
  open,
  card,
  anchorEl,
  handleClose,
  handleListKeyDown,
  popperStyle,
  children,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      transition
      style={popperStyle}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: "center top" }}>
          <Card
            useCard
            borderRadius="none"
            {...card}
            boxShadow={card?.boxShadow || "md"}
            theme={card?.theme || "default"}
          >
            <ClickAwayListener onClickAway={handleClose}>
              <Box>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  style={{ padding: 0 }}
                >
                  {children}
                </MenuList>
              </Box>
            </ClickAwayListener>
          </Card>
        </Grow>
      )}
    </Popper>
  )
}
